import { ComponentType } from "react";

import HelmetHeader from "./helmetHeader";

/* eslint-disable react/prop-types */
/* eslint-disable react/jsx-props-no-spreading */
export default (WrappedComponent: ComponentType<{ title: string }>) =>
  ({ title, ...restProps }: { title: string }) => {
    return (
      <>
        <HelmetHeader title={title} />
        <WrappedComponent title={title} {...restProps} />
      </>
    );
  };
